/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { Button, Modal } from 'antd'

interface Props{
  buttonText: string;
}

interface State {
  isModalVisible: boolean;
  isLoading: boolean;
  data: any;
}

export default class ButtonPriceModal extends React.Component<Props> {
  static defaultProps = {
    onSuccess: () => {},
    requestFunction: () => {}
  }

  state = {
    isModalVisible: false,
    isLoading: false,
    data: null
  }

  handleButtonClick = () => {
    this.setState({ isModalVisible: true })
  }

  handleModalClose = () => {
    this.setState({ isModalVisible: false })
  }

  handleOk = () =>{
    const { data } = this.state
    console.log('data', data)
  }

  render() {
    return (
      <React.Fragment>
        {this.renderButton()}
        {this.renderModal()}
      </React.Fragment>
    )
  }

  renderButton () {
    const { buttonText } = this.props

    return <Button type="primary" onClick={this.handleButtonClick} >{buttonText}</Button>
  }

  renderModal () {
    const { isModalVisible, isLoading } = this.state

    return (
      <Modal
        title="Precios Panamá Business Veterinary"
        visible={isModalVisible}
        onOk={this.handleOk}
        confirmLoading={isLoading}
        onCancel={this.handleModalClose}
        maskStyle={{ backgroundColor: 'rgba(255, 255, 255, .5)' }}
        destroyOnClose
        width={600}
        footer={[
          <Button key="back" onClick={this.handleModalClose}>
            Cerrar
          </Button>,
        ]}
      >
        <section>
          <div style={{ marginBottom: 16 }}>
            <h3>Solo ingresar el nombre de la persona que asistirá al congreso, <b>las entradas son personales e intransferibles</b>.</h3>
            <br />
            <h3>Valores netos Panamá Business Veterinary por persona:</h3>

            <h3>BECA SINGLE</h3>
            <ul>
              <li>NORMAL: USD$860</li>
              <li>CON DESCUENTO: $731</li>
            </ul>

            <h3>BECA COMPARTIDA</h3>
            <ul>
              <li>NORMAL: USD$650</li>
              <li>CON DESCUENTO: $553</li>
            </ul>

            <h3>BECA SIN ALOJAMIENTO</h3>
            <ul>
              <li>NORMAL: USD$350</li>
              <li>CON DESCUENTO: $298</li>
            </ul>
          </div>

          <h3>Transferencia Internacional.</h3>
          <ul>
            <li><b>Realizar pago aquí:</b>  <a href="https://congresoveterinario.cl/payment/paypal" target='_blanc'>https://congresoveterinario.cl/payment/paypal</a></li>
          </ul>

          <h3>PAGO POR PAYPAL.</h3>
          <ul>
            <li><b>Banco:</b> Itaú</li>
            <li><b>Titular:</b> Tischler & Asociados, SpA</li>
            <li><b>Cuenta Corriente:</b> 1200250398</li>
            <li><b>Swift:</b> ItaúCLRM</li>
            <li><b>Dirección:</b>  Mariano Sanchez Fontecilla 12200. Peñalolen, Santiago, Chile.</li>
          </ul>

          <h3>Transferencia Chile.</h3>
          <ul>
            <li><b>Banco:</b> Itaú Chile</li>
            <li><b>Titular:</b> Tischler & Asociados, SpA</li>
            <li><b>Cuenta Corriente:</b> 206568928</li>
            <li><b>RUT:</b> 76.384.378-5</li>
            <li><b>Correo:</b> <a href="mailto:mariano@congresoveterinario.cl">mariano@congresoveterinario.cl</a></li>
          </ul>

          <p>para dudas o consultas: <a href="mailto:malu@congresoveterinario.cl">malu@congresoveterinario.cl</a></p>
        </section>
      </Modal>
    )
  }
}
